<template>
  <b-row>
    <b-col cols="9">
      <form-wizard-number />
    </b-col>
    <b-col cols="3">
     <timeline-basic style="overflow: scroll;" :log_pengajuan="berkas.log_pengajuan"/>
    </b-col>
    <div>
      <b-modal id="modal-center-loading-persetujuan" centered title="Loading" hide-footer no-close-on-backdrop no-close-on-esc hide-header-close v-if="showModal === 1">
        <div v-if="this.error_check.length == 0">
          <div class="d-flex justify-content-center mt-2">
            <b-spinner
            :variant="'dark'"
            ></b-spinner>
          </div>
          <div class="d-flex justify-content-center mt-2">
          Loading....
          </div>
        </div>
        <div v-else>
          <div class="d-flex justify-content-center mt-2">
            <h4 style="color:red;">Gagal Memuat Data</h4>
          </div>
        </div>
        <b-button class="mt-3" block @click="reload()" variant="primary">Muat Ulang</b-button>
      </b-modal>
    </div>
  </b-row>
</template>

<script>
import { BRow, BCol, BButton, BContainer, BFormTextarea, BSpinner, BModal } from 'bootstrap-vue'
import FormWizardNumber from './FormWizardNumber.vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  checkExpired,
} from '@/connection-api/auth'
import {
  getPengajuanSidangDetail,
  postTerimaBerkas,
  postTolakBerkas,
} from '@/connection-api/master'
import TimelineBasic from './TimelineBasic.vue'

export default {
  components: {
    BRow,
    BCol,
    FormWizardNumber,
    BButton,
    BContainer,
    BFormTextarea,
    TimelineBasic,
    BSpinner,
    BModal,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      success_check: [],
      error_check: [],
      showModal: 1,
      berkas: {},
      catatanPenolakan: null,
    }
  },

  async mounted() {
    const response = await checkExpired()
    if(response.data.success === true)
    {
      if(response.data.biodata_complete === false)
      {
        this.$router.push({ name: 'pages-account-setting', params: {warning_show: true} })
      }
    }

    const response2 = await getPengajuanSidangDetail(this.$route.params.uuid)
    if(response2.data.success === true)
    {
      this.berkas = response2.data.data
    }

  },
  methods: {
    reload()
    {
      window.location.reload()
    },
    terimaBerkas(role)
    {
      this.$bvModal.show('modal-center-loading-persetujuan')
      this.showModal = 1
      var data = {
        role: role,
        catatan: this.catatanPenolakan,
        uuid: this.$route.params.uuid,
      }
      postTerimaBerkas(data)
      .then(response => {
        if (response.data.success === true) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan Sidang',
              icon: 'EditIcon',
              variant: 'success',
              text: 'Data berhasil disimpan',
            },
          })
          this.showModal = 0
          setTimeout(() => {
            this.$router.push({name: 'list-sidang'})
          }, 1000);
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan Sidang',
              icon: 'EditIcon',
              variant: 'danger',
              text: response.data.message,
            },
          })
          this.showModal = 0
        }
      })
      .catch(error => {
        this.showModal = 0
      });
    },
    tolakBerkas(role)
    {
      this.$bvModal.show('modal-center-loading-persetujuan')
      this.showModal = 1
       var data = {
        role: role,
        catatan: this.catatanPenolakan,
        uuid: this.$route.params.uuid,
      }
      postTolakBerkas(data)
      .then(response => {
        if (response.data.success === true) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan Sidang',
              icon: 'EditIcon',
              variant: 'success',
              text: 'Data berhasil disimpan',
            },
          })
          this.showModal = 0
          setTimeout(() => {
            this.$router.push({name: 'list-sidang'})
          }, 1000);
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan Sidang',
              icon: 'EditIcon',
              variant: 'danger',
              text: response.data.message,
            },
          })
          this.showModal = 0
        }
      })
      .catch(error => {
        this.showModal = 0
      });
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
